import { createProvider } from '@frontend/store';
import { FormsSubmissionDetailsV2Store } from './types';

export const { Provider: FormsSubmissionDetailsV2StoreProvider, useStore: useFormsSubmissionDetailsV2Store } =
  createProvider<FormsSubmissionDetailsV2Store>()((set) => ({
    activeFormId: null,
    activeAttachmentId: null,

    selectAttachment: (attachmentId: string) => {
      set({
        activeAttachmentId: attachmentId,
        activeFormId: null,
      });
    },

    selectForm: (formId: string) => {
      set({
        activeAttachmentId: null,
        activeFormId: formId,
      });
    },
  }));
